/**
 * Checkout-related Redux Actions
 */
/* tslint:disable:max-line-length */
import actionCreatorFactory, { Action, Success } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('Checkout');

interface ICheckoutStepPayload {
  id: string;
}

export type CheckoutStepAction = Action<ICheckoutStepPayload>;

export const registerStep = actionCreator<ICheckoutStepPayload>('REGISTER_STEP');
export const setActiveStep = actionCreator<ICheckoutStepPayload>('SET_ACTIVE_STEP');
export const completeStep = actionCreator<ICheckoutStepPayload>('COMPLETE_STEP');
export const removeCompletedStep = actionCreator<ICheckoutStepPayload>('REMOVE_COMPLETED_STEP');
export const saveCheckoutStepToLocalStorage = actionCreator<ISaveCheckoutStepToLocalStorageActionPayload>('SAVE_STEP_TO_LOCAL_STORAGE');
export const consumeLocallyStoredStep = actionCreator<ICheckoutStepPayload>('CONSUME_LOCALLY_STORED_STEP');

// Request Async Actions
export const requestSetCheckoutFromLocalStorage = actionCreator('REQUEST_SET_CHECKOUT_FROM_LOCAL_STORAGE');
export const requestPlaceOrder = actionCreator<IRequestPlaceOrderActionPayload>('REQUEST_PLACE_ORDER');
export const requestAddPromoCode = actionCreator<IRequestAddPromoCodeActionPayload>('REQUEST_ADD_PROMO_CODE');
export const requestDeletePromoCode = actionCreator<ICheckoutQueryVariables>('REQUEST_DELETE_PROMO_CODE');

// Async Actions
export type PlaceOrderDoneAction = Action<Success<IPlaceOrderActionPayload, GQL.IPlaceOrderPayload>>;
export const setCheckoutFromLocalStorage = actionCreator.async<void, ICheckoutStepLocalStorage[]>('SET_CHECKOUT_FROM_LOCAL_STORAGE');
export const placeOrder = actionCreator.async<IPlaceOrderActionPayload, GQL.IPlaceOrderPayload>('PLACE_ORDER');
export const addPromoCode = actionCreator.async<IAddPromoCodeActionPayload, any>('ADD_PROMO_CODE');
export const deletePromoCode = actionCreator.async<ICheckoutQueryVariables, any>('DELETE_PROMO_CODE');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/actions/checkout.ts